import { defineComponent as o, createBlock as n, openBlock as l, unref as a, mergeProps as p, withCtx as c, createElementVNode as i } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const u = /* @__PURE__ */ o({
  name: "IconArrowUpLeftInCircleFilled",
  __name: "IconArrowUpLeftInCircleFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(r) {
    const t = r;
    return (s, e) => (l(), n(a(m), p(t, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        i("path", { d: "M12 2.25c5.385 0 9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25M9.136 7.886a1.25 1.25 0 0 0-1.25 1.25v4.571a.75.75 0 0 0 1.5 0v-3.26l5.084 5.083a.75.75 0 0 0 1.06-1.06l-5.084-5.084h3.261a.75.75 0 0 0 0-1.5H9.136" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
